










































































































































helpers = require('../../helpers.coffee')
summernote = require('../../libraries/summernote.coffee')

view_model =
  props:
    id:
      default: "template-form"

    template:
      default: {}

    default_template_kind:
      default: null

    options:
      type: Object

  components:
    dropdownSelect: require('../shared/dropdown-select.vue')
    variablesDropdown: require('./variables_dropdown.vue')
    list: require('./list.vue')

  data: ->
    current_user: Session.current_user
    company: Session.current_company
    template_kind: if @default_template_kind then @default_template_kind else 'email'
    template_category_options: [{ value: null, text: this.$t('general.label.loading') }]
    template_user_options: [{ value: null, text: this.$t('general.label.loading') }]
    variables: []
    sellers: []
    disabledBnt: false
    apiErrorMessages: []
    lastSubjectCursorPosition: 0
    pristine: true
    # list option
    list_item_options:
      show_open_statistic: true
      show_reply_statistic: true
      show_user: true
      row_click_action: 'new'
      action: 'select-action'
    list_options:
      only_current_user_templates: false
    filter_options:
      show_user_filter: true
    default_options:
      name: 'show'          # options: show, disabled, hide
      category: 'show'      # options: show, disabled, hide
      show_footer: true
      preload: null
      focus: false
      modal: false
      template_type: 'OriginalTemplate' # options: OriginalTemplate, ContactSpecificTemplate

  methods:
    fillForm: (data) ->
      @$body.summernote('code', data.template.body)
      @$signature.summernote('code', Session.current_user.signature) if Session.current_user.signature
      @template.subject = data.template.subject || "-"
      @template.template_category_id = data.template.template_category_id
      @template.name = data.template.name
      @template.kind = data.template.kind
      @template.signature = Session.current_user.signature
      @template_kind = data.template.kind

    changeTemplateType: (new_kind) ->
      return if @inactive(new_kind)
      @template_kind = new_kind
      @template.kind = new_kind
      if new_kind != "email"
        @template.subject = "-"

    submit: (metadata) ->
      @ensureSummernoteCode()
      @$validator.validateAll(@template).then (success) =>
        @validateTemplate(metadata) if success

    validateTemplate: (metadata) ->
      Loader.on()
      @disabledBnt = true
      templates_resource = new TemplatesResource(Session.current_company.id)
      templates_resource.validate(@emitValidationSuccess(metadata), @failcallback, @template)

    failcallback: (response) ->
      @disabledBnt = false
      @handleApiErrors(response)

    emitValidationSuccess: (metadata) ->
      (response) =>
        metadata = {} if !metadata
        metadata.submittable = @submittable
        event = { originalEventName: 'validation-success' }
        attr = { @template, metadata }
        @disabledBnt = false
        @$emit 'validation-success', { event, attr }

    addVariablePlaceholder: (data) ->
      @template[data.attribute] += data.variable.placeholder

    loadTemplateCategories: ->
      if @element_options.preload && @element_options.preload.categories
        @template_category_options = @element_options.preload.categories
      else
        new TemplateCategoriesResource(Session.current_company.id)
          .index(@templateCategoriesSuccess, @unknownError, params: {q: {s: 'name asc'}})

    loadTemplateUsers: ->
      return unless @show_responsible_dropdown
      Loader.on()
      if @element_options.preload && @element_options.preload.users
        @template_user_options = @element_options.preload.users
      else
        new UsersResource().index(@loadTemplateUsersSuccess, @unknownError, params: {q: {s: 'name asc'}})

    loadTemplateUsersSuccess: (data) ->
      @template_user_options = []
      for user in data.users
        if user.isSeller()
          @sellers.push user
          @template_user_options.push { value: user.id, text: user.name }
      @template_user_options.unshift( value: null, text: this.$t('template.options.userSelect'))
      Loader.off()

    templateCategoriesSuccess: (data) ->
      template_category_options = for template_category in data.template_categories
        { value: template_category.id, text: template_category.name }

      template_category_options.unshift( value: null, text: this.$t('template.options.categorySelect'))

      @template_category_options = template_category_options

    loadVariables: ->
      if @element_options.preload && @element_options.preload.variables
        @variables = @element_options.preload.variables
      else
        params = { company_id: Session.current_company.id }
        new VariableResource().index(@loadVariablesSuccess, null, {params})

    loadVariablesSuccess: (resource) ->
      @variables = resource.variables

    inializeSummernote: ->
      @$signature = jQuery('#' + @id + ' .signature')
      if @element_options.focus
        summernote(@$signature, focus: true)
      else 
        summernote(@$signature)

      @$body = jQuery('#' + @id + ' .body')
      if @element_options.focus
        summernote(@$body, focus: true) 
      else
        summernote(@$body)

    ensureSummernoteCode: ->
      body = @$body.summernote('code')
      @setDirty() if body != @template.body
      @template.body = if body != '<p><br></p>' then body else ''
      signature = @$signature.summernote('code')
      @setDirty() if signature != @template.signature
      @template.signature = if signature != '<p><br></p>' then signature else ''

    updateLastSubjectCursorPosition: (evt) ->
      @lastSubjectCursorPosition = evt.target.selectionStart

    addVariableToSubject: (data) ->
      @template.subject = [
        @template.subject.slice(0, @lastSubjectCursorPosition),
        data.variable.placeholder,
        @template.subject.slice(@lastSubjectCursorPosition)
      ].join('')

    addVariableToBody: (data) ->
      @$body.summernote('editor.restoreRange')
      @$body.summernote('editor.focus')
      @$body.summernote('editor.insertText', data.variable.placeholder)

    saveSummernoteRange: ->
      @$body.summernote('editor.saveRange')

    setSummernoteCode: ->
      @$body.summernote('code', @template.body) if @template.body
      @$signature.summernote('code', @template.signature) if @template.signature

    clear: ->
      @$body.summernote('code', '')
      @errors.clear()

    nameLabel: ->
      switch @template_kind
        when "email" then this.$t('template.attributes.nameTemplate')
        when "phonecall" then this.$t('template.attributes.nameRoadMap')
        when "linkedin" then this.$t('template.attributes.nameLinkedin')
        when "social" then this.$t('template.attributes.nameSocial')
        else this.$t('template.attributes.name')

    contentLabel: ->
      switch @template_kind
        when "email" then this.$t('template.attributes.contentEmail')
        when "phonecall" then this.$t('template.attributes.contentCall') 
        when "linkedin" then this.$t('template.attributes.contentLinkedin')
        when "social" then this.$t('template.attributes.contentSocial')
        else this.$t('template.attributes.content')

    buttonLabel: ->
      switch @template_kind
        when "email" then this.$t('template.attributes.template')
        when "phonecall" then this.$t('template.attributes.roadMap')
        when "linkedin" then this.$t('template.attributes.linkedin')
        when "social" then this.$t('template.attributes.social')
        else this.$t('general.actions.create')

    inactive: (kind) ->
      ( @default_template_kind != null && @default_template_kind != kind ) || ( @template.id && @template.kind != kind)

  computed:
    show_responsible_dropdown:->
      !@company.account_setting.seller_can_edit_templates &&
      @show_company_management_options &&
      !@element_options.from_flow

    show_company_management_options: ->
       @current_user.isAdmin() || (!@current_user.requireEmailAuthorization() && !@current_user.isSeller() && !@current_user.isMonitoringManager())

    templateCategoryClassObject: ->
      {'has-error': @errors.has('template_category_id') || @errors.has('template_category')}

    subject_group_class: ->
      if @errors.has('subject')
        'has-error'
      else if @template.subject
        if @template.subject.length > 60
          'has-danger'
        else if @template.subject.length > 40
          'has-warning'

    subject_help_text: ->
      if @errors.has('subject')
        @errors.first('subject')
      else if @template.subject
        if @template.subject.length > 60
          this.$t('template.label.characterLimit60')
        else if @template.subject.length > 40
          this.$t('template.label.characterLimit40')

    element_options: ->
      Object.assign({}, @default_options, @options || {})

  watch:
    default_template_kind: ->
      @template_kind = @default_template_kind
      @template.kind = @default_template_kind
      @template.subject = "-" if @default_template_kind != 'email'

    template: (new_template) ->
      @setSummernoteCode()
      @template.kind = 'email' if @template.kind == null

    element_options: (new_options) ->
      if new_options.preload
        @loadTemplateCategories()
        @loadVariables()

  created: ->
    EventsBus.$on 'TemplateForm:Submit', @submit
    @possible_template_types = ['email', 'phonecall', 'social', 'linkedin']
    @template.kind = 'email'
    @loadTemplateCategories()
    @loadVariables()
    @loadTemplateUsers()

  mounted: ->
    @errors.clear()
    @inializeSummernote()
    @setSummernoteCode()

  beforeDestroy: ->
    EventsBus.$off 'TemplateForm:Submit', @submit
    @$body.summernote('destroy')
    @$signature.summernote('destroy')

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/form.vue